export default __webpack_public_path__ + "assets/howWork2.57400761.png";